import { getStore } from '@strangeanimals/common-vue-components/src/helpers/helpers';
import { createRouter } from '@strangeanimals/common-vue-components/src/helpers/router';
import { appLogout } from '@strangeanimals/common-vue-components/src/helpers/api';
import { checkIfAuthorized } from './helpers';
const SignIn = () => import( '../views/SignIn.vue')
const Dashboard = () => import('../views/Dashboard.vue')
const Create  = () => import( '../views/Create.vue')
const Edit  = () => import( '../views/Edit.vue')
const Report  = () => import( '../views/Report.vue')
const RefundRequestDetail  = () => import( '../views/RefundRequestDetail.vue')
const RefundRequests  = () => import( '../views/RefundRequests.vue')
const Settings  = () => import( '../views/Settings.vue')

const router = createRouter([
    {
        path: '/',
        redirect: "/dashboard"
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        beforeEnter: (to, from, next) => {
            checkIfAuthorized(next);
        }
    },
    {
        path: '/report',
        name: 'Report',
        component: Report,
        beforeEnter: (to, from, next) => {
            checkIfAuthorized(next);
        }
    },
    {
        path: '/refund-requests',
        name: 'RefundRequests',
        component: RefundRequests,
        beforeEnter: (to, from, next) => {
            const store = getStore();
            store.commit('updateTargetLink', to.path);
            store.commit('updateTargetQuery', to.query);
            checkIfAuthorized(next);
        }
    },
    {
        path: '/refund-requests/:token',
        name: 'RefundRequestDetail',
        component: RefundRequestDetail,
        beforeEnter: (to, from, next) => {
            const store = getStore();
            store.commit('updateTargetLink', to.path);
            store.commit('updateTargetQuery', to.query);
            checkIfAuthorized(next);
        }
    },
    {
        path: '/create',
        name: 'Create',
        component: Create,
        beforeEnter: (to, from, next) => {
            checkIfAuthorized(next);
        }
    },
    {
        path: '/edit',
        name: 'Edit',
        component: Edit,
        beforeEnter: (to, from, next) => {
            checkIfAuthorized(next);
        }
    },
    {
        path: '/logout',
        name: 'Logout',
        beforeEnter: (to, from, next) => {
            appLogout().then((response) => {
                const store = getStore();
                store.commit('updateUser', null);
                store.commit('updatePayments', []);

                if (response.status === 200) {
                    store.commit('updateAPIAccessToken', response.body.accessToken);
                }

                next('/sign-in');
            });
        }
    },
    {
        path: '/sign-in',
        name: 'Sign In',
        component: SignIn,
        beforeEnter: (to, from, next) => {
            const store = getStore();

            if(store.getters.isUserLoggedIn) {
                next('/dashboard');
            } else {
                next();
            }
        }
    },
    {
        path: '/settings',
        name: 'Settings',
        component: Settings,
        beforeEnter: (to, from, next) => {
            checkIfAuthorized(next);
        }
    },
]);
export default router;
